import React, {Component} from 'react';
import Slider from "react-slick";
import AOS from 'aos';
import 'aos/dist/aos.css';
import {Html5Qrcode} from "html5-qrcode";
import { TalksService } from '../../services/talks';
import { CoinsService } from '../../services/coins';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import './talk.css';

import {
  ContentHeader,
  TalkCard,
  PrimaryButton,
  PageTitle,
  Text,
  CoinsBox,
  TextMenu,
  Chat
} from '../../components';

export default class ViewTalk extends Component {
  constructor(props) {
    super(props);

    this.state = {
      "current_tab": 0,
      "render_qr_code": false,
      "camera_enabled": false,
      "render_coins_box": false,
      "checked_in": false,
      "render_challenge": false,
      "render_challenge_coins_box": false,
      "challenge_completed": CoinsService.exist("challenge", "talk")
    }

    this.challengeRef = React.createRef();
  }

  componentWillMount() {
    AOS.init();
  }

  componentDidMount() {
    this.checkIfCheckedIn();

    navigator.permissions.query({ name: 'camera' }).then(function (perm) {
      _this.setState({
        "camera_enabled": perm.state === "granted"
      })

      if (_this.state.render_qr_code && perm.state === "granted") {
        _this.initQrCode()
      }
    })

    var _this = this;
    window.navigator.permissions.query({ name: "camera" }).then(res => {
      _this.setState({
        "camera_enabled": res.state === "granted"
      })
    });

    if ('permissions' in navigator) {
      navigator.permissions.query({ name: 'camera' }).then(function (perm) {
        perm.onchange = function () {
          _this.setState({
            "camera_enabled": perm.state === "granted"
          })

          if (_this.state.render_qr_code && perm.state === "granted") {
            _this.initQrCode()
          }
        };
      });
    }
  }

  checkIfCheckedIn() {
    if (window.localStorage.getItem(`rdp-super-app-checkin-${this.props.match.params.id}`) !== null) {
      this.setState({
        "checked_in": true
      })
    }
  }

  onScanSuccess(decodedText, decodedResult) {
    // handle the scanned code as you like, for example:
    console.log(`Code matched = ${decodedText}`, decodedResult);
  }
  
  onScanFailure(error) {
    // handle scan failure, usually better to ignore and keep scanning.
    // for example:
    console.warn(`Code scan error = ${error}`);
  }

  onBack() {
    window.location = window.location.origin + window.location.pathname + "#/evento/1";
  }

  openUrl() {
    window.location = window.location.origin + window.location.pathname + "#/webview/" + this.props.match.params.id;
  }

  onCheckin() {
    var _this = this;

    this.setState({
      "render_qr_code": true
    }, function() {
      _this.initQrCode()
    })
  }

  initQrCode() {
    var _this = this;

    if (this.state.camera_enabled) {
      const html5QrCode = new Html5Qrcode("reader");

      const config = { fps: 10, qrbox: { width: 250, height: 250 } };

      const qrCodeSuccessCallback = (decodedText, decodedResult) => {
        html5QrCode.stop().then((ignore) => {
          window.localStorage.setItem(`rdp-super-app-checkin-${this.props.match.params.id}`, true)
          CoinsService.add({
            "type": "checkin",
            "target": "talk",
            "coins": 3000
          })
          _this.setState({
            "render_coins_box": true,
            "render_qr_code": false
          });
          _this.checkIfCheckedIn();
        }).catch((err) => {
          // Stop failed, handle it.
        });
        
      };

      html5QrCode.start({ facingMode: "environment" }, config, qrCodeSuccessCallback);
    }
  }

  onQrCodePermit() {
    var _this = this;
    navigator.mediaDevices.getUserMedia({video: true})
    
    setTimeout(function() {
      navigator.permissions.query({ name: 'camera' }).then(function (perm) {
        _this.setState({
          "camera_enabled": perm.state === "granted"
        })

        if (_this.state.render_qr_code && perm.state === "granted") {
          _this.initQrCode()
        }
      })
    }, 2000)
  }

  onQrCodeClose() {
    this.setState({
      "render_qr_code": false
    })
  }

  onCloseCoinsBox() {
    this.setState({
      "render_coins_box": false
    })
  }

  getData() {
    var id = this.props.match.params.id;
    return TalksService.getTalks().find(item => item.id === id);
  }

  onChallengeConfirm() {
    if (this.challengeRef.current.value.toLowerCase() === "centralidade no cliente") {
      var exist = CoinsService.exist("challenge", "talk");
      if (!exist) {
        CoinsService.add({
          "type": "challenge",
          "target": "talk",
          "coins": 6500
        });
        this.setState({
          "render_challenge_coins_box": true,
          "challenge_completed": true
        })
      }
    }
  }

  render() {
    var talk = this.getData();
    
    return (<div className="rdp-react-template-view-talk">
      {this.state.render_coins_box &&
        <CoinsBox
          title="Parabéns!"
          message="Você ganhou <b>1.500<br/><span style='color:#56c8e2;'>BV Coins</span>!</b>"
          onClose={() => this.onCloseCoinsBox()}
          buttonLabel="Voltar para a Palestra"
        />
      }
      {this.state.render_challenge_coins_box &&
        <CoinsBox
          title="Parabéns!"
          message="Você ganhou <b>6.500<br/><span style='color:#56c8e2;'>BV Coins</span>!</b>"
          onClose={() => this.setState({"render_challenge_coins_box": false})}
          buttonLabel="Voltar para a Palestra"
        />
      }
      <ContentHeader
        title="Palestra"
        onBack={() => this.onBack()}
      />
      
      {this.state.checked_in &&
        <TextMenu
          active={this.state.current_tab}
          onChange={(tab) => this.setState({"current_tab": tab})}
        />
      }

      <div className="rdp-react-template-view-talk-content" style={{
        top: this.state.checked_in ? "116px" : "70px",
        paddingTop: this.state.checked_in ? "15px" : "0px"
      }}>
        
        {this.state.render_qr_code && this.state.camera_enabled &&
          <div className="rdp-react-template-view-talk-checkin">
            <div id="reader"></div>
            <PrimaryButton
              label="Fechar Janela"
              icon="qrcode"
              onClick={() => this.onQrCodeClose()}
            />
          </div>
        }
        {this.state.render_qr_code && !this.state.camera_enabled &&
          <div className="rdp-react-template-view-talk-checkin-permission">
            <span className="rdp-react-template-view-talk-checkin-permission-icon"></span>
            <PrimaryButton
              label="Permitir acesso a câmera"
              icon="camera"
              onClick={() => this.onQrCodePermit()}
            />
            <PrimaryButton
              label="Fechar Janela"
              icon="close"
              onClick={() => this.onQrCodeClose()}
            />
          </div>
        }
        {this.state.current_tab === 0 &&
          <>
            <TalkCard
              // cover={Capa2}
              cover={""}
              profile={this.getData().palestrante_foto}
              host={this.getData().palestrante}
              title={this.getData().titulo}
              date={this.getData().horario}
            />
            {!this.state.checked_in && talk.status === "happening" &&
              <div data-aos="fade-up" data-aos-duration="1000" data-aos-delay="600">
                <PrimaryButton
                  label="Realizar Checkin"
                  icon="qrcode"
                  onClick={() => this.onCheckin()}
                />
              </div>
            }

            {!this.state.checked_in && talk.status === "not_started" &&
              <div data-aos="fade-up" data-aos-duration="1000" data-aos-delay="600">
                <PrimaryButton
                  label={`Checkin: ${talk.horario.split(" às")[0]}`}
                  icon="qrcode"
                  onClick={() => console.log("ok")}
                />
              </div>
            }

            {talk.status === "finished" &&
              <div className="rdp-react-template-view-talk-finished-message">
                <span className="rdp-react-template-view-talk-finished-message-title" data-aos="fade-up" data-aos-duration="1000" data-aos-delay="800">
                  Essa palestra já terminou!<br/>Mas o aprendizado continua...
                </span>
                <span className="rdp-react-template-view-talk-finished-message-text" data-aos="fade-up" data-aos-duration="1000" data-aos-delay="1000">
                  Acesse o conteúdo preparado sobre o tema da palestra e resgate um carimbo para o seu Passaporte Educa.Fest.
                </span>
                <div data-aos="fade-up" data-aos-duration="1000" data-aos-delay="1000">
                  <PrimaryButton
                    label="Acessar conteúdo"
                    icon="document"
                    color="#FFF"
                    onClick={() => this.openUrl()}
                  />
                </div>
              </div>
            }
          
            <div data-aos="fade-up" data-aos-duration="1000" data-aos-delay="800">
              <PageTitle label="Local da Palestra"/>
              <Text content={this.getData().local}/>
            </div>

            <div data-aos="fade-up" data-aos-duration="1000" data-aos-delay="1000">
              <PageTitle label="Sobre a Palestra"/>
              <Text content={this.getData().sobre}/>

              <PageTitle label="Competências"/>
              <ul className="rdp-react-template-view-talk-tags">
                {this.getData().competencias.map(function (item, index) {
                  return <li className="rdp-react-template-view-talk-tag" key={index}>{item}</li>
                })}
              </ul>
            </div>
          </>
        }

        {this.state.current_tab === 1 &&
          <>
            <Chat/>
          </>
        }

        {this.state.current_tab === 2 &&
          <ul className="rdp-react-template-view-talk-challenges">
            <li className="rdp-react-template-view-talk-challenge">
              <span className="rdp-react-template-view-talk-challenge-text">
                Complete as palavras-chave ditas pelo palestrante nos primeiros 10 minutos da palestra
              </span>
              {this.state.render_challenge && !this.state.challenge_completed &&
                <>
                  <input ref={this.challengeRef} className="rdp-react-template-view-talk-challenge-box-field" type="text"/>
                  <PrimaryButton
                    label="Confirmar resposta"
                    color="#FFF"
                    onClick={() => this.onChallengeConfirm()}
                  />
                </>
              }
              {!this.state.render_challenge && !this.state.challenge_completed &&
                <PrimaryButton
                  label="Iniciar desafio"
                  color="#FFF"
                  onClick={() => this.setState({"render_challenge": true})}
                />
              }
              {this.state.challenge_completed &&
                <PrimaryButton
                  label="Você já realizou este desafio."
                  color="#FFF"
                  onClick={() => console.log("oi")}
                />
              }
            </li>
          </ul>
        }

      </div>
    </div>);
  }
}
